import { DoubleSide, PlaneBufferGeometry, Vector2 } from "three";
import * as THREE from "three";
// @ts-ignore
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline';
// @ts-ignore
import Perlin from 'perlin.js';
import { TextureManger } from "./gameMain";
export enum BlobSize {
    SMALL,
    NORMAL,
    BIG
}
export enum BlobStatus {
    NORMAL,
    UNSTABLE,
    DEAD,
    PREPARE,
    SUPER
}
export class Blob extends THREE.Object3D {
    private colors = [
        0xffffff,
        0xffe468,
        0x63ff72,
        0x6e8bf6,
        0xff5650,
        0x363636,
        0xd463ff,
        0x63fffd,
        0xff874e,
        0xff4ee3
    ];
    private currentColor = 0xffff00;
    public OnDead!: (type: number) => boolean;
    private guideShape = new THREE.Shape();

    private blobNormalGeometry = new THREE.ShapeGeometry(this.guideShape);
    private blobNormalMaterial = new THREE.MeshBasicMaterial({ color: this.currentColor, side: DoubleSide, transparent: true });
    public blobNormal = new THREE.Mesh(this.blobNormalGeometry, this.blobNormalMaterial);

    private blobBigGeometry = new THREE.ShapeGeometry(this.guideShape);
    private blobBigMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, side: DoubleSide, transparent: true });
    public blobBig = new THREE.Mesh(this.blobBigGeometry, this.blobBigMaterial);

    private blobLargeGeometry = new THREE.ShapeGeometry(this.guideShape);
    private blobLargeMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, side: DoubleSide, transparent: true });
    public blobLarge = new THREE.Mesh(this.blobLargeGeometry, this.blobLargeMaterial);
    private opacityBig = 0.5;
    private opacityLarge = 0.5;

    public shapePoints!: THREE.Vector2[];
    public shapePointsBig!: THREE.Vector2[];
    public shapePointsLarge!: THREE.Vector2[];

    public blobSize: BlobSize = BlobSize.NORMAL;
    private blobStatus: BlobStatus = BlobStatus.NORMAL;
    private hasShape = false;
    private face: Face = new Face();

    constructor() {
        super();
        Perlin.seed(Math.random());
        this.setRandomColor();
        this.face.renderOrder = 4;
        this.add(this.face);
    }
    public randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    private setRandomColor() {
        this.currentColor = this.colors[this.randomIntFromInterval(0, this.colors.length - 1)];
        this.blobNormalMaterial.color.setHex(this.currentColor);
        this.blobBigMaterial.color.setHex(this.currentColor);
        this.blobBigMaterial.opacity = this.opacityBig;
        this.blobLargeMaterial.color.setHex(this.currentColor);
        this.blobLargeMaterial.opacity = this.opacityLarge;
    }
    public randomFace() {
        this.face.SetRandom();
        this.setRandomColor();
    }

    public SetInit() {
        this.face.init();
        this.setRandomColor();
        this.blobStatus = BlobStatus.NORMAL;
    }
    private deadType: number = 0;
    public SetHit(val: boolean) {
        if (val) {
            this.deadType = 0;
            this.SetStatus(BlobStatus.DEAD);
        }
    }
    public SetNoTouch(val: boolean) {
        if (val) {
            this.deadType = 1;
            this.SetStatus(BlobStatus.DEAD);
        }
    }
    public centerPoint: THREE.Vector2 = new THREE.Vector2();
    public GetStatus(): BlobStatus {
        return this.blobStatus;
    }
    public SetStatus(newStatus: BlobStatus, IsForce: boolean = false) {
        if (!IsForce && (this.blobStatus == newStatus || this.blobStatus == BlobStatus.PREPARE || this.blobStatus == BlobStatus.SUPER)) return;
        this.blobStatus = newStatus
        switch (newStatus) {
            case BlobStatus.NORMAL:
                this.blobNormalMaterial.color.setHex(this.currentColor);
                this.blobBigMaterial.color.setHex(this.currentColor);
                this.blobLargeMaterial.color.setHex(this.currentColor);
                this.face.Resume();
                break;
            case BlobStatus.UNSTABLE:
                this.face.SetX();
                break;
            case BlobStatus.DEAD:
                this.blobStatus = BlobStatus.PREPARE;
                //this.face.SetDead();
                if (this.OnDead(this.deadType)) {
                    this.SetStatusPrepare();
                } else {
                    //this.blobStatus = BlobStatus.NORMAL;
                }
                break;

            case BlobStatus.SUPER:
                this.SetStatusSuper();
                break;
        }
    }
    private timer: any = 0;
    public SetStatusSuper() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.blobNormalMaterial.opacity = (this.blobNormalMaterial.opacity == 0.1) ? 0.7 : 0.1;
            this.blobBigMaterial.opacity = (this.blobBigMaterial.opacity == 0.1) ? 0.7 : 0.1;
            this.blobLargeMaterial.opacity = (this.blobLargeMaterial.opacity == 0.1) ? 0.7 : 0.1;
        }, 30);
        setTimeout(() => {
            this.ResetStatusNormal();
            clearInterval(this.timer);
            this.blobNormalMaterial.opacity = 1;
            this.blobBigMaterial.opacity = this.opacityBig;
            this.blobLargeMaterial.opacity = this.opacityLarge;
            if (!this.IsAllTouchOn) { this.SetNoTouch(true); }
        }, 5000);
        //this.blobNormalMaterial.color.setHex(0xffffff);
        //this.blobBigMaterial.color.setHex(0xffffff);
        //this.blobLargeMaterial.color.setHex(0xffffff);
    }
    public SetStatusPrepare() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.blobNormalMaterial.opacity = (this.blobNormalMaterial.opacity == 0.1) ? 0.7 : 0.1;
            this.blobBigMaterial.opacity = (this.blobBigMaterial.opacity == 0.1) ? 0.7 : 0.1;
            this.blobLargeMaterial.opacity = (this.blobLargeMaterial.opacity == 0.1) ? 0.7 : 0.1;
        }, 30);
        setTimeout(() => {
            this.ResetStatusNormal();
            clearInterval(this.timer);
            this.blobNormalMaterial.opacity = 1;
            this.blobBigMaterial.opacity = this.opacityBig;
            this.blobLargeMaterial.opacity = this.opacityLarge;
            if (!this.IsAllTouchOn) { this.SetNoTouch(true); }
        }, 2000);
        //this.blobNormalMaterial.color.setHex(0xff0000);
        //this.blobBigMaterial.color.setHex(0xff0000);
        //this.blobLargeMaterial.color.setHex(0xff0000);
    }
    private ResetStatusNormal() {
        //console.log("ResetStatusNormal")
        this.SetStatus(BlobStatus.NORMAL, true);
    }
    public IsAllTouchOn = false;
    public SetPoints(points: THREE.Vector3[]) {
        const pos = [];
        pos.push(new THREE.Vector3().lerpVectors(points[0], points[1], 0.5));
        pos.push(new THREE.Vector3().lerpVectors(points[1], points[2], 0.5));
        pos.push(new THREE.Vector3().lerpVectors(points[2], points[3], 0.5));
        this.centerPoint.x = (pos[0].x + pos[1].x + pos[2].x) / 3;
        this.centerPoint.y = (pos[0].y + pos[1].y + pos[2].y) / 3;
        this.face.position.x = this.centerPoint.x;
        this.face.position.y = this.centerPoint.y;
        var n = new THREE.Vector2(this.centerPoint.x, this.centerPoint.y);
        //13,10,7

        const dist0 = n.distanceTo(new THREE.Vector2(points[0].x, points[0].y));
        const dist1 = n.distanceTo(new THREE.Vector2(points[1].x, points[1].y));
        const dist2 = n.distanceTo(new THREE.Vector2(points[2].x, points[2].y));
        const dist = (dist0 + dist1 + dist2) / 3;

        if (dist < 4) {
            this.blobSize = BlobSize.SMALL;
        } else if (dist > 6) {
            this.blobSize = BlobSize.BIG;
        } else {
            this.blobSize = BlobSize.NORMAL;
        }

        const curve0 = new THREE.QuadraticBezierCurve(
            new THREE.Vector2(pos[0].x, pos[0].y),
            new THREE.Vector2(points[0].x, points[0].y),
            new THREE.Vector2(pos[2].x, pos[2].y)
        );
        const curve1 = new THREE.QuadraticBezierCurve(
            new THREE.Vector2(pos[1].x, pos[1].y),
            new THREE.Vector2(points[1].x, points[1].y),
            new THREE.Vector2(pos[0].x, pos[0].y)
        );
        const curve2 = new THREE.QuadraticBezierCurve(
            new THREE.Vector2(pos[2].x, pos[2].y),
            new THREE.Vector2(points[2].x, points[2].y),
            new THREE.Vector2(pos[1].x, pos[1].y)
        );
        this.shapePoints = curve0.getPoints(20);
        this.shapePoints = this.shapePoints.concat(curve2.getPoints(20))
        this.shapePoints = this.shapePoints.concat(curve1.getPoints(20))

        this.shapePointsBig = curve0.getPoints(20);
        this.shapePointsBig = this.shapePointsBig.concat(curve2.getPoints(20))
        this.shapePointsBig = this.shapePointsBig.concat(curve1.getPoints(20))

        this.shapePointsLarge = curve0.getPoints(20);
        this.shapePointsLarge = this.shapePointsLarge.concat(curve2.getPoints(20))
        this.shapePointsLarge = this.shapePointsLarge.concat(curve1.getPoints(20))

        var time = performance.now() * 0.0009;

        for (var i = 0; i < this.shapePoints.length; i++) {
            var p = this.shapePoints[i];
            const dist = p.distanceTo(this.centerPoint);
            this.shapePointsBig[i].add((new Vector2().subVectors(p, this.centerPoint)).normalize().multiplyScalar(dist * 2 / 7));
            this.shapePointsLarge[i].add((new Vector2().subVectors(p, this.centerPoint)).normalize().multiplyScalar(dist * 3 / 7));
            //p.multiplyScalar(0.9 + 0.05 * Perlin.simplex2(p.x + time, p.y));
            //this.shapePointsLarge[i].multiplyScalar(0.9 + 0.05 * Perlin.simplex2(this.shapePointsLarge[i].x + time, this.shapePointsLarge[i].y));
        }
        if (!this.hasShape) {
            this.hasShape = true;
            const shape = new THREE.Shape(this.shapePoints);
            const shapeBig = new THREE.Shape(this.shapePointsBig);
            const shapeLarge = new THREE.Shape(this.shapePointsLarge);
            this.blobLarge.renderOrder = -1;
            this.blobBig.renderOrder = 0;
            this.blobNormal.renderOrder = 0;
            this.add(this.blobLarge);
            this.add(this.blobBig);
            this.add(this.blobNormal);
            /*shape.moveTo(pos[0].x, pos[0].y);
            shape.quadraticCurveTo(points[0].x, points[0].y,pos[2].x, pos[2].y );
            shape.quadraticCurveTo(points[2].x, points[2].y,pos[1].x, pos[1].y );
            shape.quadraticCurveTo(points[1].x, points[1].y,pos[0].x, pos[0].y );*/

            this.SetBlob(shape, shapeBig, shapeLarge);
        } else {
            this.UpdateBlob();
        }
    }

    public ResetBlob() {
        this.remove(this.blobNormal);
        this.blobNormal.geometry.dispose();
        this.blobNormalGeometry.dispose();

        this.remove(this.blobBig);
        this.blobBig.geometry.dispose();
        this.blobBigGeometry.dispose();

        this.remove(this.blobLarge);
        this.blobLarge.geometry.dispose();
        this.blobLargeGeometry.dispose();

        this.hasShape = false;
        this.face.Reset();
    }

    public SetBlob(shape: THREE.Shape, shapeBig: THREE.Shape, shapeLarge: THREE.Shape) {
        this.blobLarge.geometry.dispose();
        this.blobLargeGeometry.dispose();
        this.blobLarge.geometry = new THREE.ShapeGeometry(shapeLarge);

        this.blobBig.geometry.dispose();
        this.blobBigGeometry.dispose();
        this.blobBig.geometry = new THREE.ShapeGeometry(shapeBig);

        this.blobNormal.geometry.dispose();
        this.blobNormalGeometry.dispose();
        this.blobNormal.geometry = new THREE.ShapeGeometry(shape);
    }

    public UpdateBlob() {
        for (let i = 0; i < this.shapePoints.length; i++) {
            this.blobNormal.geometry.attributes.position.setXYZ(i, this.shapePoints[i].x, this.shapePoints[i].y, 0);
            this.blobBig.geometry.attributes.position.setXYZ(i, this.shapePointsBig[i].x, this.shapePointsBig[i].y, 0);
            this.blobLarge.geometry.attributes.position.setXYZ(i, this.shapePointsLarge[i].x, this.shapePointsLarge[i].y, 0);
        }
        //this.line.geometry.setFromPoints(bpoints);
        this.blobNormal.geometry.attributes.position.needsUpdate = true;
        this.blobBig.geometry.attributes.position.needsUpdate = true;
        this.blobLarge.geometry.attributes.position.needsUpdate = true;
    }
    /*public getPoints() {
        return this.shapePoints;
    }*/
}

export class Face extends THREE.Object3D {
    private textureManager: TextureManger = new TextureManger();
    private eye: FaceElement = new FaceElement(1, 1);
    private nose: FaceElement = new FaceElement(1, 1);
    private mouth: FaceElement = new FaceElement(1, 1);

    private eyeData: Array<number> = [28, 35, 36, 37, 38, 39, 40, 42, 43, 44, 45, 47];
    private noseData: Array<number> = [14, 15, 21, 22, 23, 24, 25, 26, 29, 30, 31, 32, 33];
    private mouthData: Array<number> = [0, 7, 8, 9, 10, 11, 12, 16, 17, 18, 19];
    constructor() {
        super();

        this.textureManager.InitTexture('/assets/nobc_atlas_face_1024.png');


        // 0 mask
        // 5 XX
    }
    public Reset() {
        this.eye.SetAtlas(1);
        this.nose.SetAtlas(1);
        this.mouth.SetAtlas(1);
    }
    public init() {
        this.eye.InitTexture(this.textureManager.GetMaterial(), 7, 2.5);
        this.nose.InitTexture(this.textureManager.GetMaterial(), 7, 2.5);
        this.mouth.InitTexture(this.textureManager.GetMaterial(), 7, 2.5);
        this.mouth.renderOrder = 7;
        this.nose.renderOrder = 6;
        this.eye.renderOrder = 5;

        this.eye.position.y = 0.3;
        this.nose.position.y = 0;
        this.mouth.position.y = -0.3;

        this.SetRandom();

        this.add(this.eye);
        this.add(this.nose);
        this.add(this.mouth);
    }
    private currentIndex = new THREE.Vector3();
    public SetRandom() {
        this.currentIndex.x = this.eyeData[Math.floor(Math.random() * this.eyeData.length)];
        this.currentIndex.y = this.noseData[Math.floor(Math.random() * this.noseData.length)];
        this.currentIndex.z = this.mouthData[Math.floor(Math.random() * this.mouthData.length)];
        this.Resume();
    }
    public SetX() {
        this.eye.SetAtlas(1);
        this.nose.SetAtlas(46);
        this.mouth.SetAtlas(1);
    }
    public SetDead() {
        this.eye.SetAtlas(1);
        this.nose.SetAtlas(5);
        this.mouth.SetAtlas(1);
    }
    public Resume() {
        this.eye.SetAtlas(this.currentIndex.x);
        this.nose.SetAtlas(this.currentIndex.y);
        this.mouth.SetAtlas(this.currentIndex.z);
    }
}

export class FaceElement extends THREE.Object3D {
    private geometry!: PlaneBufferGeometry;
    private mesh!: THREE.Mesh;
    public offset: THREE.Vector2 = new THREE.Vector2();
    private material!: THREE.MeshBasicMaterial;
    private atlasSize: number = 0;

    constructor(public targetWidth: number, public targetHeight: number) {
        super();
    }

    public SetRenderOrder(order: number) {
        this.mesh!.renderOrder = order;
    }

    public InitTexture(material: THREE.MeshBasicMaterial, atlasSize: number, sizeMultiplier: number = 1.0) {

        this.material = material.clone() as THREE.MeshBasicMaterial;
        this.geometry = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight);
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.mesh.renderOrder = 0;
        this.mesh.scale.set(sizeMultiplier, sizeMultiplier, sizeMultiplier);
        this.atlasSize = atlasSize;
        this.material.map?.repeat.set(1 / atlasSize, 1 / atlasSize);
        this.add(this.mesh);
        this.mesh.onBeforeRender = () => {
            this.material.map?.offset.set(this.offset.x, this.offset.y);
        };
    }

    public SetAtlas(index: number) {
        this.offset.x = index % this.atlasSize * 1 / this.atlasSize;
        this.offset.y = Math.floor(index / this.atlasSize) * 1 / this.atlasSize;
    }

    public Dispose() {
        this.geometry?.dispose();
        this.mesh.geometry?.dispose();
        this.remove(this.mesh);
    }
}